import Install from './Install';

export default Install
export { Install as Base }
